var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classBlock},[_c('Menu',{class:_vm.classBlock+'-menu ' + _vm.getLogoColor}),_c('router-link',{attrs:{"to":'/'}},[_c('div',{class:_vm.classBlock+'-logo ' + _vm.getLogoColor})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }